import { Skeleton } from "@mui/material";

const AccountDetailsSkeleton = () => {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="tf-field style-1 mb_15">
          <Skeleton variant="rounded" height={40} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="tf-field style-1 mb_15">
          <Skeleton variant="rounded" height={40} />
        </div>
      </div>
      <div className="col-md-12">
        <div className="tf-field style-1 mb_15">
          <Skeleton variant="rounded" height={40} />
        </div>
      </div>
      <div className="col-md-10">
        <div className="tf-field style-1 mb_15">
          <Skeleton variant="rounded" height={40} />
        </div>
      </div>
      <div className="col-md-2">
        <div className="tf-field style-1 ">
          <Skeleton variant="rounded" height={40} />
        </div>
      </div>
    </div>
  );
};

export default AccountDetailsSkeleton;
